import app from 'flarum/app';
import Page from 'flarum/components/Page';
import FieldList from '../fields/FieldList';
import ValueHistory from '../utils/ValueHistory';
import SaveControls from '../components/SaveControls';

/* global m */

export default class DebugPage extends Page {
    init() {
        app.store.pushObject({
            id: 'debug-file-uid',
            type: 'formulaire-files',
            attributes: {
                filename: 'test.pdf',
                humanSize: '32.1kB',
                url: 'https://example.com/',
            },
        });

        this.configuration = [
            {
                key: 'aaa',
                type: 'short',
                title: 'An short text',
            },
            {
                key: 'bbb',
                type: 'short',
                title: 'A short text with regex',
                description: 'Required and must contain an a',
                required: true,
                regex: 'a',
            },
            {
                key: 'ccc',
                type: 'short',
                title: 'An email',
                email: true,
            },
            {
                key: 'ddd',
                type: 'long',
                description: 'A long text without a title',
            },
            {
                key: 'eee',
                type: 'long',
                title: 'Rich text',
                rich: true,
            },
            {
                key: 'fff',
                type: 'date',
                title: 'A date after 2019',
                min: '2020-01-01',
            },
            {
                key: 'ggg',
                type: 'number',
                title: 'A number',
                max: 5,
            },
            {
                key: 'hhh',
                type: 'upload',
                title: 'Resume',
                description: 'Upload your file',
            },
            {
                key: 'iii',
                type: 'items',
                title: 'Qualifications',
                fields: [
                    {
                        key: 'aaa',
                        type: 'short',
                        title: 'First name',
                        required: true,
                    },
                    {
                        key: 'bbb',
                        type: 'short',
                        title: 'Last name',
                        description: 'With description',
                    },
                ],
            },
            {
                type: 'content',
                content: 'Hello World',
            },
        ];

        this.submission = {
            aaa: {
                value: 'Hello World',
            },
            eee: {
                value: 'Some **bold** and a [link](https://example.com/)',
                html: '<p>Some <strong>bold</strong> and a <a href="https://example.com/" rel=" nofollow ugc">link</a></p>',
            },
            hhh: {
                value: [
                    'debug-file-uid',
                ],
            },
            iii: {
                value: [
                    {
                        aaa: {
                            value: 'Myself',
                        },
                    },
                    {
                        aaa: {
                            value: 'John',
                        },
                        bbb: {
                            value: 'Doe',
                        },
                    },
                ],
            },
        };

        this.history = new ValueHistory(this.configuration);
    }

    view() {
        const list = new FieldList({
            configs: this.history.value,
            submission: this.submission,
            uploader: { // Fake object so that the form can render
                uploading: false,
            },
            onchange: () => {
                this.history.save();
            },
            expertMode: true,
            validationErrors: {
                ccc: {
                    errors: [
                        'The test field is required.',
                    ],
                },
                iii: {
                    1: {
                        bbb: {
                            errors: [
                                'Another test error message.',
                            ],
                        },
                    },
                },
            },
        });

        return m('.FormulaireDebugPage', [
            m('div', [
                m('pre', JSON.stringify(this.history.value, null, 4)),
                m('pre', JSON.stringify(this.submission, null, 4)),
            ]),
            m('div', [
                list.configureView(),
                SaveControls.component({
                    history: this.history,
                    floating: true,
                }),
            ]),
            m('div', [
                list.listView(),
            ]),
            m('div', [
                list.listView(true),
            ]),
        ]);
    }
}
